"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTableRow = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledTableRow = styled_components_1.default.tr `
  display: table;
  table-layout: fixed;
  width: 100%;

  &:last-child {
    border-bottom: 1px solid ${config_1.colors.pavement};
  }
`;
